<template>
  <div>
    <div class="bill-card__title">
      Mensalidade de {{ bill.month_name }}
    </div>

    <div class="bill-card__bill-status bill-card__bill-status--paid">
      <div class="bill-card__bill-status-title">
        Pagamento realizado
      </div>
    </div>

    <div class="bill-card__data">
      <div class="bill-card__data-item">
        <strong>Mensalidade:</strong>
        <span class="bill-card__data-item__value">
          {{ bill.full_value | formatCurrency }}
        </span>
      </div>

      <div class="bill-card__data-divider"></div>

      <div class="bill-card__data-item">
        <strong>Data:</strong>
        <span class="bill-card__data-item__value">{{ paidDate }}</span>
      </div>

      <div class="bill-card__data-divider"></div>

      <div class="bill-card__data-item">
        <strong>Pagamento:</strong>
        <span class="bill-card__data-item__value">
          <template v-if="isCreditCard">
            <span class="bill-card__card-brand">
              {{ creditCard.card_brand }}
            </span>
            final {{ creditCard.last_digits }}
          </template>
          <template v-else>
            Boleto
          </template>
        </span>
      </div>
    </div>

    <router-link
      tag="button"
      :to="{ name: 'payment-receipt', params: { billId: bill.id } }"
      class="z-button z-button--primary z-button--block"
    >
      Comprovante de pagamento
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@quero/zilla-core/src/atoms/z-caption';

.bill-card__title {
  @extend .z-caption;
  margin-bottom: var(--space-small);
  text-align: center;
}

.bill-card__bill-status {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-large);
  text-align: center;
}

.bill-card__bill-status--paid {
  color: var(--color-support-success-deep);
}

.bill-card__bill-status-title {
  font-size: rem(19);
  line-height: rem(23);
  margin-bottom: var(--space-large);
}

.bill-card__data {
  margin-bottom: var(--space-large);

  @media (min-width: $screen-md-min) {
    display: flex;
    justify-content: space-around;
    margin-bottom: var(--space-jumbo);
  }
}

.bill-card__data-item {
  color: var(--color-neutral-dark-gray);
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-small);
}

.bill-card__data-item__value {
  @media (min-width: $screen-md-min) {
    display: block;
  }
}

.bill-card__card-brand {
  text-transform: capitalize;
}

.bill-card__data-divider {
  background-color: var(--color-neutral-lighter-gray);
  display: none;
  width: 2px;

  @media (min-width: $screen-md-min) {
    display: block;
  }
}
</style>

<script>
import DateUtils from 'utils/date-utils';

export default {
  props: {
    bill: {
      type: Object,
      default: () => ({}),
    },
    paymentMethod: {
      type: String,
      default: 'boleto',
    },
    creditCard: {
      type: Object,
      default: (() => {}),
    },
  },
  computed: {
    isCreditCard() {
      return this.paymentMethod === 'credit_card';
    },
    paidDateMonthName() {
      return DateUtils.getMonthName(this.bill.paid_date);
    },
    paidDay() {
      return DateUtils.getDay(this.bill.paid_date);
    },
    paidDate() {
      return `${this.paidDay} de ${this.paidDateMonthName}`;
    },
  },
};
</script>
